import React, { useEffect, useState } from "react";
import { fetchAllUsers } from "../../services/adminUserService";
import { useNavigate } from "react-router-dom";

const AdminUsersTable = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {

    const loadUsers = async () => {
      try {
        const response = await fetchAllUsers();
        setUsers(response.data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    loadUsers();
  }, []);

  const handleShowMore = (userId) => {
    navigate(`/admin/users/${userId}`);
  };

  if (loading) {
    return <p>Loading users...</p>;
  }


  return (
    <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "15px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f5f5f5" }}>
          <th style={th}>Picture</th>
          <th style={th}>Name</th>
          <th style={th}>Email</th>
          <th style={th}>Last Login</th>
          <th style={th}>Status</th>
          <th style={th}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {users.map((user) => {
         
          return (
            <tr key={user.id}>
              <td style={td}>
                {user.picture ? (
                  <img src={user.picture} alt="avatar" width={40} />
                ) : (
                  "N/A"
                )}
              </td>
              <td style={td}>{user.name || "N/A"}</td>
              <td style={td}>{user.email}</td>
              <td style={td}>
                {user.lastLogin
                  ? new Date(user.lastLogin).toLocaleString()
                  : "N/A"}
              </td>
              <td style={td}>{user.suspended ? "Suspended" : "Active"}</td>
              <td style={td}>
                <button onClick={() => handleShowMore(user.id)}>
                  Show More
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

const th = { padding: "10px", border: "1px solid #ddd", textAlign: "left" };
const td = { padding: "10px", border: "1px solid #ddd" };

export default AdminUsersTable;
